import { writable } from "svelte/store";
let FeatureMenuStore;
export default FeatureMenuStore = writable([]);
